module.exports = __webpack_public_path__ + "img/5_uk.d66c8495.svg";